import { useCallback, useEffect, useMemo, useState } from 'react';
import _ from 'lodash';
import { browserHistory } from 'common/utils/browserHistory';

export const useAddCaseDetailsClientNeeds = ({
  assistanceRequest,
  clientNeedsFromQuery,
  contactId,
  groupForms,
  multipleClientNeedsFlag,
}) => {
  const [clientNeeds, setClientNeeds] = useState([]);

  useEffect(() => {
    setClientNeeds(clientNeedsFromQuery || []);
  }, [clientNeedsFromQuery]);

  const personConditions = useMemo(() => (
    clientNeeds?.map((condition) => ({
      label: _.upperFirst(condition?.name),
      value: condition?.id,
    })) || []
  ), [clientNeeds]);

  const showPersonCondition = multipleClientNeedsFlag && !_.isEmpty(personConditions);

  const validateClientNeedsField = useCallback((value) => {
    if (multipleClientNeedsFlag) {
      return (!value || value.length === 0) ? 'Required' : undefined;
    }
    return !value ? 'Required' : undefined;
  }, [multipleClientNeedsFlag]);

  const validateClientNeeds = useCallback((values, form) => {
    if (!showPersonCondition) {
      return true;
    }

    form.blur('client_needs');
    const clientNeedsValue = values?.client_needs;
    const clientNeedsEmpty = multipleClientNeedsFlag ?
      (!clientNeedsValue || clientNeedsValue.length === 0) :
      (!clientNeedsValue);

    return !clientNeedsEmpty;
  }, [multipleClientNeedsFlag, showPersonCondition]);

  const checkGroupFormsAndNavigate = useCallback((prefix) => (
    _.isEmpty(groupForms) ?
      browserHistory.push(`${prefix}/contacts/${contactId}/cases/new/review`) :
      browserHistory.push(`${prefix}/contacts/${contactId}/cases/new/add-case-assessments`)
  ), [contactId, groupForms]);

  const onCreateCaseDetails = useCallback((values, form) => {
    if (!validateClientNeeds(values, form)) {
      return;
    }

    const assistanceRequestId = _.get(assistanceRequest, 'id');
    const prefix = assistanceRequestId ? `/assistance-requests/${assistanceRequestId}` : '';
    checkGroupFormsAndNavigate(prefix);
  }, [assistanceRequest, checkGroupFormsAndNavigate, validateClientNeeds]);

  const cancel = useCallback(() => {
    const assistanceRequestId = _.get(assistanceRequest, 'id');
    if (assistanceRequestId) {
      browserHistory.push(`/dashboard/new/assistance-requests/${assistanceRequestId}`);
    } else {
      browserHistory.push(`/facesheet/${contactId}/cases`);
    }
  }, [assistanceRequest, contactId]);

  return {
    cancel,
    onCreateCaseDetails,
    personConditions,
    showPersonCondition,
    validateClientNeedsField,
  };
};
